import {SvgIcon, SvgIconProps} from "@mui/material";
import {FC} from "react";

export const AppIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="256.000000pt" height="192.000000pt" viewBox="0 0 256.000000 192.000000"
        preserveAspectRatio="xMidYMid meet"
    >
        <g transform="translate(0.000000,192.000000) scale(0.100000,-0.100000)"
           fill="#000000" stroke="none">
            <path d="M33 1904 l-23 -5 0 -876 c0 -481 3 -873 7 -871 5 1 46 22 93 46 47
23 123 52 170 63 74 19 103 21 240 16 127 -4 186 -12 325 -42 94 -20 199 -42
235 -49 l65 -13 -42 -18 -43 -17 0 -68 0 -68 78 34 c189 81 366 109 657 101
176 -4 255 -12 485 -46 151 -23 276 -41 277 -41 2 0 3 29 3 65 l0 64 -32 6
c-263 45 -562 82 -738 91 -98 4 -147 11 -178 25 -52 22 -165 90 -159 95 12 12
283 21 406 13 115 -7 517 -58 669 -85 l32 -6 0 66 c0 60 -2 66 -22 71 -79 17
-539 77 -666 86 -167 12 -345 2 -484 -26 l-78 -16 -55 47 c-30 26 -52 51 -48
55 15 14 139 47 233 62 246 40 427 32 925 -43 72 -11 145 -22 162 -25 l33 -6
0 64 0 63 -252 37 c-354 51 -466 61 -658 54 -184 -7 -294 -26 -451 -81 l-97
-34 -211 211 c-116 116 -209 212 -207 215 3 2 88 -14 190 -35 l186 -38 0 -117
0 -117 65 30 c167 75 360 111 600 111 180 0 319 -14 632 -62 106 -17 195 -30
198 -30 3 0 5 30 3 67 l-3 67 -235 35 -235 36 -3 68 c-3 59 -1 67 15 67 10 0
118 -15 240 -34 l223 -33 0 69 0 68 -32 1 c-18 0 -125 15 -238 32 l-205 32 -3
68 c-3 62 -1 67 18 67 11 0 110 -13 220 -30 110 -16 209 -30 220 -30 18 0 20
7 20 63 l0 62 -237 35 -238 35 -3 68 c-4 81 -26 78 241 37 108 -16 206 -30
217 -30 18 0 20 7 20 63 l0 63 -252 37 c-349 50 -476 61 -658 54 -207 -8 -375
-44 -532 -114 l-58 -26 -2 -167 -3 -167 -180 128 c-278 199 -448 296 -590 334
-62 16 -213 27 -252 19z m1652 -92 c-3 -8 -5 -19 -5 -25 0 -7 -11 -13 -24 -13
-16 -1 -23 3 -20 11 3 7 1 16 -5 20 -16 9 -13 25 4 25 8 0 15 5 15 10 0 6 8 5
20 -2 11 -7 18 -19 15 -26z m174 0 c-5 -2 -9 -11 -9 -20 0 -11 -9 -18 -24 -18
-17 -1 -23 2 -19 12 3 8 0 21 -7 29 -10 12 -9 15 4 15 9 0 16 5 16 10 0 6 11
3 24 -7 13 -10 20 -19 15 -21z m-344 -10 c-3 -8 -5 -20 -5 -29 0 -9 -6 -13
-14 -10 -7 3 -19 0 -26 -6 -10 -10 -12 -8 -6 7 3 10 1 25 -5 32 -9 11 -8 14 5
14 9 0 16 7 16 15 0 13 3 13 20 3 11 -7 18 -19 15 -26z m495 18 c0 -5 8 -10
17 -10 13 0 14 -3 5 -12 -7 -7 -12 -20 -12 -29 0 -22 -36 -14 -42 9 -6 23 -4
37 5 35 4 -2 7 2 7 7 0 6 5 10 10 10 6 0 10 -4 10 -10z m-665 -48 c-3 -8 -5
-19 -5 -25 0 -7 -12 -17 -26 -24 -22 -10 -25 -9 -22 5 1 9 -1 23 -5 30 -5 7
-2 14 7 18 9 3 16 12 16 20 0 12 4 12 20 2 11 -7 18 -19 15 -26z m252 -42 c12
0 13 -3 4 -14 -6 -7 -9 -21 -5 -30 5 -12 1 -16 -17 -14 -32 4 -43 42 -21 69
14 17 18 17 20 4 2 -8 10 -15 19 -15z m171 -16 c-4 -6 -5 -20 -1 -30 6 -16 5
-17 -9 -6 -13 11 -18 11 -24 0 -6 -9 -10 -4 -14 17 -3 18 0 36 9 46 12 15 15
15 31 0 10 -10 13 -20 8 -27z m-593 24 c5 4 5 -1 2 -11 -4 -10 -7 -28 -7 -39
0 -11 -5 -18 -12 -15 -7 2 -19 -3 -26 -12 -12 -14 -13 -13 -9 6 3 13 1 26 -4
29 -5 3 -1 16 8 29 12 15 22 20 29 14 6 -5 15 -5 19 -1z m766 -33 c-3 -5 -4
-19 -2 -30 2 -15 0 -17 -9 -8 -7 6 -18 9 -25 7 -20 -8 -26 48 -7 62 12 8 19 7
32 -5 9 -9 14 -20 11 -26z m-531 15 c0 -5 7 -10 16 -10 13 0 14 -3 5 -14 -6
-7 -8 -22 -4 -31 5 -14 3 -17 -10 -12 -9 3 -20 1 -24 -6 -4 -7 -10 0 -15 18
-4 18 -4 31 2 33 6 2 10 10 10 18 0 8 5 14 10 14 6 0 10 -4 10 -10z m-153 -50
c13 0 13 -3 3 -15 -7 -8 -10 -21 -7 -29 9 -24 -36 -25 -48 -2 -8 15 -5 25 10
42 11 13 22 19 23 14 2 -6 11 -10 19 -10z m425 -61 c-9 -31 -53 -39 -45 -9 3
11 0 20 -6 20 -6 0 -11 5 -11 10 0 6 7 10 15 10 8 0 15 8 15 17 0 14 3 14 19
-4 14 -15 18 -28 13 -44z m168 31 c11 -11 16 -20 10 -20 -5 0 -10 -8 -10 -17
0 -12 -8 -18 -24 -19 -17 -1 -23 2 -19 12 3 8 0 21 -7 29 -10 12 -9 15 4 15 9
0 16 5 16 10 0 15 8 12 30 -10z m-335 -28 c-3 -8 -5 -20 -5 -29 0 -9 -6 -13
-14 -10 -7 3 -19 0 -26 -6 -10 -10 -12 -8 -6 7 3 10 1 25 -5 32 -9 11 -8 14 5
14 9 0 16 7 16 15 0 13 3 13 20 3 11 -7 18 -19 15 -26z m508 -26 c-4 -21 -8
-24 -19 -15 -8 6 -14 8 -15 3 0 -5 -5 2 -10 16 -7 17 -7 26 0 28 6 2 11 11 11
20 0 13 3 12 19 -5 13 -13 17 -29 14 -47z m-680 -16 c-7 -30 -3 -26 -32 -35
-19 -6 -23 -4 -18 8 3 8 1 19 -5 25 -8 8 -7 13 5 18 9 3 17 12 17 20 0 12 4
12 20 2 14 -9 18 -19 13 -38z m254 -30 c12 0 13 -3 4 -14 -6 -7 -9 -21 -5 -30
5 -12 1 -16 -17 -14 -32 4 -43 42 -21 69 14 17 18 17 20 4 2 -8 10 -15 19 -15z
m171 -16 c-4 -6 -5 -20 -2 -30 6 -15 4 -17 -6 -7 -7 6 -18 9 -25 6 -19 -7 -23
38 -6 58 12 15 15 15 31 0 10 -10 13 -20 8 -27z m-593 24 c5 4 5 -1 2 -11 -4
-10 -7 -28 -7 -39 0 -14 -5 -18 -15 -14 -8 3 -19 -3 -25 -12 -10 -15 -11 -14
-7 5 3 13 1 26 -4 29 -5 3 -1 16 8 29 12 15 22 20 29 14 6 -5 15 -5 19 -1z
m764 -32 c-4 -5 -5 -14 -3 -21 3 -8 -4 -12 -19 -12 -19 0 -26 6 -30 25 -7 36
19 55 43 33 9 -9 14 -20 9 -25z m-512 4 c12 0 13 -3 4 -14 -6 -7 -8 -22 -4
-31 5 -14 3 -17 -10 -12 -9 3 -20 1 -24 -6 -4 -7 -10 -1 -14 17 -6 19 -3 33 9
47 9 11 18 15 20 9 2 -5 11 -10 19 -10z m-987 -25 c15 -14 18 -14 30 0 17 20
27 19 33 -6 5 -17 9 -19 26 -10 28 15 31 14 31 -14 0 -20 5 -25 25 -25 22 0
24 -2 15 -20 -9 -17 -7 -20 16 -26 l27 -7 -23 -17 c-35 -26 -7 -34 38 -11 22
11 51 34 65 51 14 16 28 30 31 30 12 0 -25 -95 -46 -117 -64 -69 -213 -105
-345 -85 -131 21 -191 62 -208 142 l-7 35 29 -27 c33 -32 104 -60 123 -48 9 6
7 10 -9 15 -28 9 -27 21 5 29 21 6 24 10 14 21 -15 18 -5 35 21 35 13 0 19 7
19 21 0 17 4 20 24 15 19 -5 26 -1 31 14 8 24 13 25 35 5z m817 -15 c13 0 13
-3 3 -15 -7 -8 -10 -21 -7 -29 9 -24 -36 -25 -48 -2 -8 15 -5 25 10 42 11 13
22 19 23 14 2 -6 11 -10 19 -10z m434 -30 c10 0 10 -3 1 -12 -7 -7 -12 -19
-12 -27 0 -10 -10 -17 -24 -17 -18 -1 -22 2 -19 17 3 11 0 19 -6 19 -6 0 -11
5 -11 10 0 6 7 10 15 10 8 0 15 8 15 18 1 16 1 16 14 0 7 -10 19 -18 27 -18z
m154 6 c20 -20 6 -60 -22 -63 -16 -2 -21 2 -16 12 3 9 0 22 -7 30 -10 12 -9
15 4 15 9 0 16 5 16 10 0 14 9 13 25 -4z m-330 -34 c-3 -8 -5 -20 -5 -29 0 -9
-6 -13 -14 -10 -7 3 -19 0 -26 -6 -10 -9 -11 -7 -6 10 4 12 2 24 -3 28 -6 3
-4 13 7 23 13 14 21 16 35 8 9 -6 15 -17 12 -24z m508 -26 c-4 -21 -8 -24 -19
-15 -8 6 -14 8 -15 3 0 -5 -5 4 -9 20 -6 19 -5 32 3 41 18 20 46 -14 40 -49z
m-680 -16 c-7 -30 -3 -26 -32 -35 -19 -6 -23 -4 -18 8 3 8 1 19 -5 25 -8 8 -7
13 5 18 9 3 17 12 17 20 0 12 4 12 20 2 14 -9 18 -19 13 -38z m254 -30 c12 0
13 -3 4 -14 -6 -7 -9 -21 -5 -30 5 -12 1 -16 -17 -14 -32 4 -44 43 -21 66 12
13 18 14 20 5 2 -7 10 -13 19 -13z m171 -17 c-6 -7 -7 -16 -4 -21 3 -5 -5 -9
-19 -9 -28 0 -38 33 -16 58 12 15 15 15 31 0 11 -10 14 -20 8 -28z m171 -7
c-4 -5 -5 -14 -3 -21 3 -8 -4 -12 -19 -12 -19 0 -26 6 -30 25 -7 36 19 55 43
33 9 -9 14 -20 9 -25z m-529 14 c0 -5 7 -10 16 -10 13 0 14 -3 5 -14 -6 -7 -8
-22 -4 -31 5 -14 3 -17 -10 -12 -9 3 -20 1 -24 -6 -4 -7 -10 0 -15 18 -4 18
-4 31 2 33 6 2 10 10 10 18 0 8 5 14 10 14 6 0 10 -4 10 -10z m281 -80 c10 0
10 -3 1 -12 -7 -7 -12 -19 -12 -27 0 -10 -10 -17 -24 -17 -17 -1 -23 2 -19 12
3 8 0 21 -7 29 -10 12 -9 15 4 15 9 0 16 8 16 18 1 16 1 16 14 0 7 -10 19 -18
27 -18z m154 6 c20 -20 6 -60 -22 -63 -16 -2 -21 2 -16 12 3 9 0 22 -7 30 -10
12 -9 15 4 15 9 0 16 5 16 10 0 14 9 13 25 -4z m-330 -34 c-3 -8 -5 -19 -5
-26 0 -21 -36 -13 -47 11 -9 18 -8 23 3 23 8 0 14 7 14 15 0 13 3 13 20 3 11
-7 18 -19 15 -26z m508 -26 c-4 -21 -8 -24 -19 -15 -8 6 -14 8 -15 3 0 -5 -5
4 -9 20 -6 19 -5 32 3 41 18 20 46 -14 40 -49z m-446 -38 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m194 -9 c9 -6 2 -9 -23 -9 -37 0 -37 1 -21
20 11 13 19 16 24 9 4 -6 13 -15 20 -20z m167 -26 c-6 -7 -7 -17 -3 -23 4 -6
-3 -9 -17 -7 -30 3 -44 45 -21 62 20 15 55 -13 41 -32z m-93 -57 c20 -20 6
-60 -22 -63 -16 -2 -21 2 -16 12 3 9 0 22 -7 30 -10 12 -9 15 4 15 9 0 16 5
16 10 0 14 9 13 25 -4z m176 -62 c-5 -19 -10 -24 -15 -16 -4 7 -12 10 -17 7
-5 -4 -9 0 -9 9 0 8 -3 22 -7 32 -4 12 -3 15 5 10 8 -4 12 -1 12 10 0 16 2 15
19 -3 15 -16 18 -28 12 -49z m-335 40 c-3 -9 -6 -21 -6 -27 0 -7 -10 -13 -23
-13 -18 -1 -23 3 -23 20 1 24 13 36 40 36 12 0 16 -5 12 -16z m-176 -45 c0 -5
-5 -7 -10 -4 -6 4 -17 1 -25 -5 -15 -12 -22 0 -8 13 10 11 43 8 43 -4z m-1030
-39 c23 -46 29 -47 89 -20 24 11 44 20 46 20 2 0 -1 -17 -6 -37 -14 -63 -15
-63 58 -63 l67 0 -38 -39 -38 -39 50 -26 c28 -14 53 -30 56 -35 3 -5 -19 -12
-49 -16 -30 -3 -55 -9 -55 -12 0 -2 16 -25 36 -49 20 -24 32 -44 28 -44 -5 1
-35 7 -66 14 l-58 14 7 -55 6 -55 -52 37 c-28 21 -53 36 -55 34 -2 -2 -13 -23
-25 -46 -12 -24 -23 -43 -26 -43 -2 0 -16 20 -30 45 l-27 45 -51 -40 c-28 -21
-52 -38 -53 -37 -1 1 2 25 6 52 4 28 7 51 5 53 -1 2 -30 -8 -64 -22 -33 -13
-61 -22 -61 -19 0 3 16 27 36 54 l36 49 -57 0 c-65 0 -65 6 6 54 l51 34 -36
27 c-20 15 -33 31 -31 36 3 4 27 11 53 14 72 10 70 9 62 57 -5 24 -7 45 -4 47
2 2 26 -5 53 -17 47 -19 71 -16 71 10 0 10 30 58 36 58 2 0 13 -18 24 -40z
m860 19 c0 -15 -5 -19 -15 -15 -8 3 -15 1 -15 -4 0 -6 -5 -10 -11 -10 -5 0 -7
5 -4 10 4 6 1 17 -5 25 -11 13 -7 15 19 15 25 0 31 -4 31 -21z m-167 -12 c4 3
7 1 7 -5 0 -6 -4 -13 -9 -16 -5 -3 -7 -16 -3 -28 3 -15 2 -19 -7 -14 -6 4 -19
2 -28 -6 -15 -11 -16 -11 -10 4 3 10 2 20 -3 23 -6 4 -3 16 7 30 12 15 22 20
29 14 6 -5 14 -6 17 -2z"/>
        </g>
    </SvgIcon>
)